/**
 * FireworksOverlay - Easter egg celebration animation
 * Triggered by ←→←→ on last ghost capture
 */

import { useEffect, useState } from 'react';
import './FireworksOverlay.css';

interface FireworksOverlayProps {
  onComplete?: () => void;
}

export function FireworksOverlay({ onComplete }: FireworksOverlayProps) {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    // Generate firework particles
    const newParticles: Particle[] = [];
    const colors = ['#FFFF00', '#00FFFF', '#FFB8FF', '#FF0000', '#00FF00'];
    const positions = [
      { x: 25, delay: 0 },
      { x: 75, delay: 500 },
      { x: 40, delay: 1000 },
      { x: 60, delay: 1500 },
    ];

    positions.forEach((pos, burstIndex) => {
      for (let i = 0; i < 20; i++) {
        const angle = (Math.PI * 2 * i) / 20;
        const speed = 2 + Math.random() * 3;
        newParticles.push({
          id: `${burstIndex}-${i}`,
          x: pos.x,
          y: 50,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          color: colors[Math.floor(Math.random() * colors.length)],
          delay: pos.delay,
          size: 4 + Math.random() * 4,
        });
      }
    });

    setParticles(newParticles);

    // Cleanup after animation
    const timer = setTimeout(() => {
      onComplete?.();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fireworks-overlay">
      {particles.map(p => (
        <div
          key={p.id}
          className="firework-particle"
          style={{
            '--start-x': `${p.x}%`,
            '--start-y': `${p.y}%`,
            '--vx': p.vx,
            '--vy': p.vy,
            '--color': p.color,
            '--delay': `${p.delay}ms`,
            '--size': `${p.size}px`,
          } as React.CSSProperties}
        />
      ))}
      <div className="fireworks-text">VICTORY!</div>
    </div>
  );
}

interface Particle {
  id: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  color: string;
  delay: number;
  size: number;
}
